"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8843],{

/***/ 67408:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ei": function() { return /* binding */ LabelXS; },
/* harmony export */   "ew": function() { return /* binding */ LabelS; },
/* harmony export */   "i_": function() { return /* binding */ LabelM; },
/* harmony export */   "vt": function() { return /* binding */ LabelL; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var baseui_typography__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(94858);
/* harmony import */ var _styles_colors__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32317);







var LabelL = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(_param, ref) /*#__PURE__*/ {
    var children = _param.children, weight = _param.weight, align = _param.align, _color = _param.color, color = _color === void 0 ? _styles_colors__WEBPACK_IMPORTED_MODULE_2__/* .colors.gray700 */ .O.gray700 : _color, whiteSpace = _param.whiteSpace, $style = _param.$style, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "children",
        "weight",
        "align",
        "color",
        "whiteSpace",
        "$style"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(baseui_typography__WEBPACK_IMPORTED_MODULE_4__/* .LabelLarge */ .D9, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        font: "LabelL",
        $style: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
            fontWeight: weight,
            textAlign: align,
            whiteSpace: whiteSpace
        }, $style),
        color: color
    }, props), {
        ref: ref,
        children: children
    }));
});
var LabelM = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(_param, ref) /*#__PURE__*/ {
    var children = _param.children, weight = _param.weight, align = _param.align, _color = _param.color, color = _color === void 0 ? _styles_colors__WEBPACK_IMPORTED_MODULE_2__/* .colors.gray700 */ .O.gray700 : _color, whiteSpace = _param.whiteSpace, $style = _param.$style, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "children",
        "weight",
        "align",
        "color",
        "whiteSpace",
        "$style"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(baseui_typography__WEBPACK_IMPORTED_MODULE_4__/* .LabelMedium */ .Uc, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        font: "LabelM",
        $style: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
            fontWeight: weight,
            textAlign: align,
            whiteSpace: whiteSpace
        }, $style),
        color: color
    }, props), {
        ref: ref,
        children: children
    }));
});
var LabelS = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(_param, ref) /*#__PURE__*/ {
    var children = _param.children, weight = _param.weight, align = _param.align, _color = _param.color, color = _color === void 0 ? _styles_colors__WEBPACK_IMPORTED_MODULE_2__/* .colors.gray700 */ .O.gray700 : _color, whiteSpace = _param.whiteSpace, $style = _param.$style, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "children",
        "weight",
        "align",
        "color",
        "whiteSpace",
        "$style"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(baseui_typography__WEBPACK_IMPORTED_MODULE_4__/* .LabelSmall */ .S$, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        font: "LabelS",
        $style: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
            fontWeight: weight,
            textAlign: align,
            whiteSpace: whiteSpace
        }, $style),
        color: color
    }, props), {
        ref: ref,
        children: children
    }));
});
var LabelXS = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(_param, ref) /*#__PURE__*/ {
    var children = _param.children, weight = _param.weight, align = _param.align, _color = _param.color, color = _color === void 0 ? _styles_colors__WEBPACK_IMPORTED_MODULE_2__/* .colors.gray700 */ .O.gray700 : _color, whiteSpace = _param.whiteSpace, $style = _param.$style, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "children",
        "weight",
        "align",
        "color",
        "whiteSpace",
        "$style"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(baseui_typography__WEBPACK_IMPORTED_MODULE_4__/* .LabelSmall */ .S$, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        font: "LabelXS",
        $style: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
            fontWeight: weight,
            textAlign: align,
            whiteSpace: whiteSpace
        }, $style),
        color: color
    }, props), {
        ref: ref,
        children: children
    }));
});


/***/ }),

/***/ 58817:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ useOverrides; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var baseui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92338);


var useOverrides = function(defaults, overrides) {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        return (0,baseui__WEBPACK_IMPORTED_MODULE_1__/* .mergeOverrides */ .aO)(defaults, overrides !== null && overrides !== void 0 ? overrides : {});
    }, [
        defaults,
        overrides
    ]);
};


/***/ }),

/***/ 16333:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ useSpace; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(828);
/* harmony import */ var _styles_media_query__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97475);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);




var useSpace = function(param) {
    var spaceTop = param.spaceTop, spaceBottom = param.spaceBottom;
    var marginTop = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        if (!spaceTop) return {};
        if (typeof spaceTop === "number") {
            return {
                marginTop: spaceTop + "px"
            };
        }
        var _spaceTop = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(spaceTop, 3), mobile = _spaceTop[0], tablet = _spaceTop[1], desktop = _spaceTop[2];
        var _obj;
        return _obj = {
            marginTop: mobile + "px"
        }, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, _styles_media_query__WEBPACK_IMPORTED_MODULE_3__/* .mediaQuery.TABLET */ .c.TABLET, {
            marginTop: tablet + "px"
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, _styles_media_query__WEBPACK_IMPORTED_MODULE_3__/* .mediaQuery.DESKTOP */ .c.DESKTOP, {
            marginTop: desktop + "px"
        }), _obj;
    }, [
        spaceTop
    ]);
    var marginBottom = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        if (!spaceBottom) return {};
        if (typeof spaceBottom === "number") {
            return {
                marginBottom: spaceBottom + "px"
            };
        }
        var _spaceBottom = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(spaceBottom, 3), mobile = _spaceBottom[0], tablet = _spaceBottom[1], desktop = _spaceBottom[2];
        var _obj;
        return _obj = {
            marginBottom: mobile + "px"
        }, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, _styles_media_query__WEBPACK_IMPORTED_MODULE_3__/* .mediaQuery.TABLET */ .c.TABLET, {
            marginBottom: tablet + "px"
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, _styles_media_query__WEBPACK_IMPORTED_MODULE_3__/* .mediaQuery.DESKTOP */ .c.DESKTOP, {
            marginBottom: desktop + "px"
        }), _obj;
    }, [
        spaceBottom
    ]);
    return {
        marginTop: marginTop,
        marginBottom: marginBottom
    };
};


/***/ }),

/***/ 60369:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$H": function() { return /* binding */ GetExaminationsByOffsetDocument; },
/* harmony export */   "AJ": function() { return /* binding */ UploadType; },
/* harmony export */   "BI": function() { return /* binding */ ApproveCertificateDocument; },
/* harmony export */   "C4": function() { return /* binding */ SetRelationshipWithUserDocument; },
/* harmony export */   "Cj": function() { return /* binding */ GetAdministratorUserDocument; },
/* harmony export */   "DE": function() { return /* binding */ ConfirmPhoneVerificationCodeDocument; },
/* harmony export */   "Eo": function() { return /* binding */ CreateProfessionalDocument; },
/* harmony export */   "F6": function() { return /* binding */ ResetPasswordDocument; },
/* harmony export */   "Fw": function() { return /* binding */ CreateIdentificationDocument; },
/* harmony export */   "Gd": function() { return /* binding */ InvalidateExaminationDocument; },
/* harmony export */   "HM": function() { return /* binding */ GenerateUploadPathByNonMemberDocument; },
/* harmony export */   "IU": function() { return /* binding */ RequestPhoneVerificationCodeDocument; },
/* harmony export */   "IV": function() { return /* binding */ CreateNoticeDocument; },
/* harmony export */   "JY": function() { return /* binding */ InterpretationStatus; },
/* harmony export */   "Ju": function() { return /* binding */ GetInquiryDocument; },
/* harmony export */   "Kc": function() { return /* binding */ LogoutDocument; },
/* harmony export */   "LF": function() { return /* binding */ BlockUserDocument; },
/* harmony export */   "Lh": function() { return /* binding */ UpdateNoticeDocument; },
/* harmony export */   "MV": function() { return /* binding */ UpdateExaminationDocument; },
/* harmony export */   "M_": function() { return /* binding */ UpdateInterpretationDocument; },
/* harmony export */   "Ms": function() { return /* binding */ CreateAdministratorDocument; },
/* harmony export */   "N$": function() { return /* binding */ GetEarningsStatisticsDocument; },
/* harmony export */   "NX": function() { return /* binding */ ProfessionalMeDocument; },
/* harmony export */   "Nt": function() { return /* binding */ CreateFaqDocument; },
/* harmony export */   "O5": function() { return /* binding */ GetProfessionalRegistrationsByOffsetDocument; },
/* harmony export */   "OM": function() { return /* binding */ CancelInterpretationDocument; },
/* harmony export */   "OR": function() { return /* binding */ NoticeType; },
/* harmony export */   "Oj": function() { return /* binding */ RejectCertificateDocument; },
/* harmony export */   "Om": function() { return /* binding */ GetAllFaqCategoriesDocument; },
/* harmony export */   "Ot": function() { return /* binding */ GetAdministratorUsersByOffsetDocument; },
/* harmony export */   "P9": function() { return /* binding */ GetProfessionalUserDocument; },
/* harmony export */   "PO": function() { return /* binding */ UpdateUserSettingsDocument; },
/* harmony export */   "Ph": function() { return /* binding */ ChangePasswordDocument; },
/* harmony export */   "Pn": function() { return /* binding */ GetExaminationsInProgressByOffsetDocument; },
/* harmony export */   "Q5": function() { return /* binding */ GetEarningssByCursorDocument; },
/* harmony export */   "Qx": function() { return /* binding */ CertificateStatus; },
/* harmony export */   "Qy": function() { return /* binding */ GetEarningsStatisticsForAdminDocument; },
/* harmony export */   "RG": function() { return /* binding */ GetRelationshipsByOffsetDocument; },
/* harmony export */   "R_": function() { return /* binding */ DeleteExaminationDocument; },
/* harmony export */   "Rh": function() { return /* binding */ DeleteNoticeDocument; },
/* harmony export */   "Rv": function() { return /* binding */ GetInquiriesByOffsetDocument; },
/* harmony export */   "Tn": function() { return /* binding */ GetExaminationDocument; },
/* harmony export */   "Tx": function() { return /* binding */ GetFaqsByOffsetDocument; },
/* harmony export */   "VC": function() { return /* binding */ GetInterpretationDocument; },
/* harmony export */   "Vs": function() { return /* binding */ CompleteSettlementDocument; },
/* harmony export */   "Wd": function() { return /* binding */ SetUserToDiseasesDocument; },
/* harmony export */   "Wg": function() { return /* binding */ GetProfessionalEarningsByOffsetDocument; },
/* harmony export */   "XP": function() { return /* binding */ CreateInquiryByNonMemberDocument; },
/* harmony export */   "Xo": function() { return /* binding */ GetEarningTotalAmountsByCursorDocument; },
/* harmony export */   "Y7": function() { return /* binding */ GetTotalUserCountDocument; },
/* harmony export */   "YA": function() { return /* binding */ ConfirmEmailVerificationCodeDocument; },
/* harmony export */   "YE": function() { return /* binding */ GetSettlementDocument; },
/* harmony export */   "YV": function() { return /* binding */ GetInterpretationCountsDocument; },
/* harmony export */   "ZF": function() { return /* binding */ UpdateInspectionScoreDocument; },
/* harmony export */   "ZL": function() { return /* binding */ UserSortBy; },
/* harmony export */   "ZP": function() { return /* binding */ NoticeSortBy; },
/* harmony export */   "ZV": function() { return /* binding */ UpdateSettlementDueDateDocument; },
/* harmony export */   "ZX": function() { return /* binding */ CreateInquiryByMemberDocument; },
/* harmony export */   "_": function() { return /* binding */ SetAdministratorDocument; },
/* harmony export */   "_y": function() { return /* binding */ GetLatestSettlementDocument; },
/* harmony export */   "a7": function() { return /* binding */ UpsertBankAccountDocument; },
/* harmony export */   "b1": function() { return /* binding */ LoginDocument; },
/* harmony export */   "bN": function() { return /* binding */ UpdateFaqDocument; },
/* harmony export */   "cP": function() { return /* binding */ GetUserByAdminDocument; },
/* harmony export */   "dP": function() { return /* binding */ DownloadProfessionalEarningsExcelDocument; },
/* harmony export */   "dj": function() { return /* binding */ SetProfileImageDocument; },
/* harmony export */   "eF": function() { return /* binding */ DeleteFaqDocument; },
/* harmony export */   "en": function() { return /* binding */ MeDocument; },
/* harmony export */   "es": function() { return /* binding */ CreateInterpretationDocument; },
/* harmony export */   "fp": function() { return /* binding */ GetHospitalsByOffsetDocument; },
/* harmony export */   "ft": function() { return /* binding */ UpdateUserDocument; },
/* harmony export */   "h2": function() { return /* binding */ GenerateDownloadPathDocument; },
/* harmony export */   "i4": function() { return /* binding */ UserRole; },
/* harmony export */   "ij": function() { return /* binding */ ValidateExaminationDocument; },
/* harmony export */   "in": function() { return /* binding */ AdminMeDocument; },
/* harmony export */   "jG": function() { return /* binding */ InquirySortBy; },
/* harmony export */   "jf": function() { return /* binding */ GetAdminHomeStatisticsDocument; },
/* harmony export */   "k9": function() { return /* binding */ GetSettlementsByOffsetDocument; },
/* harmony export */   "kI": function() { return /* binding */ CreateFileByNonMemberDocument; },
/* harmony export */   "kt": function() { return /* binding */ GetUsersByOffsetDocument; },
/* harmony export */   "m6": function() { return /* binding */ UpdateAdministratorRoleDocument; },
/* harmony export */   "mV": function() { return /* binding */ GetNoticesByOffsetDocument; },
/* harmony export */   "ms": function() { return /* binding */ GetProfessionalUsersByOffsetDocument; },
/* harmony export */   "n_": function() { return /* binding */ GetBankAccountByUserIdDocument; },
/* harmony export */   "nq": function() { return /* binding */ GetAllProfessionalGroupsDocument; },
/* harmony export */   "o0": function() { return /* binding */ CreateFileDocument; },
/* harmony export */   "ox": function() { return /* binding */ SubmitInterpretationDocument; },
/* harmony export */   "qV": function() { return /* binding */ RequestEmailVerificationCodeDocument; },
/* harmony export */   "rY": function() { return /* binding */ SaveIdentifiedUserDocument; },
/* harmony export */   "sI": function() { return /* binding */ ResetCertificateDocument; },
/* harmony export */   "sf": function() { return /* binding */ ExaminationStatus; },
/* harmony export */   "sm": function() { return /* binding */ DeleteUserDocument; },
/* harmony export */   "st": function() { return /* binding */ GetDiseasesByOffsetDocument; },
/* harmony export */   "tw": function() { return /* binding */ AdminRole; },
/* harmony export */   "uD": function() { return /* binding */ CreateExaminationDocument; },
/* harmony export */   "uV": function() { return /* binding */ CreateUserDocument; },
/* harmony export */   "uo": function() { return /* binding */ GetAllBanksDocument; },
/* harmony export */   "v9": function() { return /* binding */ GenerateUploadPathDocument; },
/* harmony export */   "vg": function() { return /* binding */ CheckPasswordDocument; },
/* harmony export */   "vm": function() { return /* binding */ SaveInterpretationDocument; },
/* harmony export */   "vr": function() { return /* binding */ PatientMeDocument; },
/* harmony export */   "wc": function() { return /* binding */ CreateInspectionDocument; },
/* harmony export */   "xX": function() { return /* binding */ FaqSortBy; },
/* harmony export */   "xd": function() { return /* binding */ ExaminationSortBy; },
/* harmony export */   "xm": function() { return /* binding */ GetAllMedicalImagingTypesDocument; },
/* harmony export */   "yP": function() { return /* binding */ GetEarningsByOffsetDocument; },
/* harmony export */   "yT": function() { return /* binding */ GetExaminationCountsByUserIdDocument; },
/* harmony export */   "zU": function() { return /* binding */ CreateAnswerDocument; }
/* harmony export */ });
/* unused harmony exports DiseaseSortBy, EarningSortKey, InterpretationSortBy, RelationshipSortBy, BankAccountPartsFragmentDoc, DiseasePartsFragmentDoc, ExaminationToDiseasePartsFragmentDoc, MedicalImagingTypePartsFragmentDoc, ExaminationToMedicalImagingTypePartsFragmentDoc, EarningPartsFragmentDoc, FilePartsFragmentDoc, InterpretationPartsFragmentDoc, ExaminationPartsFragmentDoc, ExaminationCountPartsFragmentDoc, FaqPartsFragmentDoc, InquiryPartsFragmentDoc, InspectionPartsFragmentDoc, NoticePartsFragmentDoc, OffsetPageInfoPartsFragmentDoc, CursorPageInfoPartsFragmentDoc, ProfessionalEarningsPartsFragmentDoc, RelationshipPartsFragmentDoc, SettlementPartsFragmentDoc, SettlementWithEarningsPartsFragmentDoc, UserSettingPartsFragmentDoc, UserToDiseasePartsFragmentDoc, UserPartsFragmentDoc, PatientUserPartsFragmentDoc, CertificatePartsFragmentDoc, ProfessionalPartsFragmentDoc, ProfessionalUserPartsFragmentDoc, AdminPartsFragmentDoc, AdministratorUserPartsFragmentDoc, CreateBankAccountDocument, UpdateBankAccountDocument, RemoveBankAccountDocument, GetCertificateByProfessionalIdDocument, GetAllDiseasesDocument, GetEarningTotalAmountDocument, GetExaminationOptionsDocument, GetFaqDocument, GetSavedInterpretationsDocument, GetInterpretationsByOffsetDocument, ApproveInterpretationDocument, RejectInterpretationDocument, GetNoticeDocument, GetUserSettingDocument */
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(29815);

var AdminRole;
(function(AdminRole) {
    AdminRole[/** 기본 권한 */ "Basic"] = "Basic";
    AdminRole[/** 전체 접근 권한 */ "FullAccess"] = "FullAccess";
    AdminRole[/** 개인정보 접근 권한 */ "PrivacyAccess"] = "PrivacyAccess";
    AdminRole[/** 읽기 전용 */ "ReadOnly"] = "ReadOnly";
})(AdminRole || (AdminRole = {}));
var CertificateStatus;
(function(CertificateStatus) {
    CertificateStatus[/** 증명서 승인 완료 */ "Certified"] = "Certified";
    CertificateStatus[/** 증명서 승인 거부 */ "Rejected"] = "Rejected";
    CertificateStatus[/** 증명서 승인 대기 중 */ "Waiting"] = "Waiting";
})(CertificateStatus || (CertificateStatus = {}));
var DiseaseSortBy;
(function(DiseaseSortBy) {
    DiseaseSortBy[/** 오름차순으로 생성일자 정렬 */ "CreatedAtAsc"] = "CreatedAtAsc";
    DiseaseSortBy[/** 내림차순으로 생성일자 정렬 */ "CreatedAtDesc"] = "CreatedAtDesc";
    DiseaseSortBy[/** 오름차순으로 ID 정렬 */ "IdAsc"] = "IdAsc";
    DiseaseSortBy[/** 내림차순으로 ID 정렬 */ "IdDesc"] = "IdDesc";
    DiseaseSortBy[/** 오름차순으로 이름 정렬 */ "NameAsc"] = "NameAsc";
    DiseaseSortBy[/** 내림차순으로 이름 정렬 */ "NameDesc"] = "NameDesc";
})(DiseaseSortBy || (DiseaseSortBy = {}));
var EarningSortKey;
(function(EarningSortKey) {
    EarningSortKey["CreatedAt"] = "CreatedAt";
})(EarningSortKey || (EarningSortKey = {}));
var ExaminationSortBy;
(function(ExaminationSortBy) {
    ExaminationSortBy[/** 오름차순으로 생성일 정렬 */ "CreatedAtAsc"] = "CreatedAtAsc";
    ExaminationSortBy[/** 내림차순으로 생성일 정렬 */ "CreatedAtDesc"] = "CreatedAtDesc";
    ExaminationSortBy[/** 오름차순으로 사진 수 정렬 */ "FileCountAsc"] = "FileCountAsc";
    ExaminationSortBy[/** 내림차순으로 사진 수 정렬 */ "FileCountDesc"] = "FileCountDesc";
    ExaminationSortBy[/** 오름차순으로 검수인 닉네임 정렬 */ "InspectorNicknameAsc"] = "InspectorNicknameAsc";
    ExaminationSortBy[/** 내림차순으로 검수인 닉네임 정렬 */ "InspectorNicknameDesc"] = "InspectorNicknameDesc";
    ExaminationSortBy[/** 오름차순으로 해석인 닉네임 정렬 */ "InterpreterNicknameAsc"] = "InterpreterNicknameAsc";
    ExaminationSortBy[/** 내림차순으로 해석인 닉네임 정렬 */ "InterpreterNicknameDesc"] = "InterpreterNicknameDesc";
    ExaminationSortBy[/** 오름차순으로 환자 닉네임 정렬 */ "PatientNicknameAsc"] = "PatientNicknameAsc";
    ExaminationSortBy[/** 내림차순으로 환자 닉네임 정렬 */ "PatientNicknameDesc"] = "PatientNicknameDesc";
    ExaminationSortBy[/** 오름차순으로 환자 Public ID 정렬 */ "PatientPublicIdAsc"] = "PatientPublicIdAsc";
    ExaminationSortBy[/** 내림차순으로 환자 Public ID 정렬 */ "PatientPublicIdDesc"] = "PatientPublicIdDesc";
    ExaminationSortBy[/** 오름차순으로 Public ID 정렬 */ "PublicIdAsc"] = "PublicIdAsc";
    ExaminationSortBy[/** 내림차순으로 Public ID 정렬 */ "PublicIdDesc"] = "PublicIdDesc";
    ExaminationSortBy[/** 오름차순으로 제목 정렬 */ "TitleAsc"] = "TitleAsc";
    ExaminationSortBy[/** 내림차순으로 제목 정렬 */ "TitleDesc"] = "TitleDesc";
})(ExaminationSortBy || (ExaminationSortBy = {}));
var ExaminationStatus;
(function(ExaminationStatus) {
    ExaminationStatus[/** 관리자로부터 해석이 승인되고 모든 과정이 완료됨 */ "Done"] = "Done";
    ExaminationStatus[/** 의료인이 해석할 결과지를 선택하여 해석이 진행중인 상태 */ "Interpreting"] = "Interpreting";
    ExaminationStatus[/** 환자가 업로드한 결과지가 양식에 맞지 않는 경우 */ "Invalid"] = "Invalid";
    ExaminationStatus[/** 환자가 업로드한 결과지의 승인을 기다리는 상태 */ "Pending"] = "Pending";
    ExaminationStatus[/** 환자가 업로드한 결과지가 승인된 후 해석을 기다리는 상태 */ "Waiting"] = "Waiting";
})(ExaminationStatus || (ExaminationStatus = {}));
var FaqSortBy;
(function(FaqSortBy) {
    FaqSortBy[/** 오름차순으로 생성일자 정렬 */ "CreatedAtAsc"] = "CreatedAtAsc";
    FaqSortBy[/** 내림차순으로 생성일자 정렬 */ "CreatedAtDesc"] = "CreatedAtDesc";
})(FaqSortBy || (FaqSortBy = {}));
var InquirySortBy;
(function(InquirySortBy) {
    InquirySortBy[/** 오름차순으로 생성일자 정렬 */ "CreatedAtAsc"] = "CreatedAtAsc";
    InquirySortBy[/** 내림차순으로 생성일자 정렬 */ "CreatedAtDesc"] = "CreatedAtDesc";
    InquirySortBy[/** 오름차순으로 이메일 정렬 */ "EmailAsc"] = "EmailAsc";
    InquirySortBy[/** 내림차순으로 이메일 정렬 */ "EmailDesc"] = "EmailDesc";
})(InquirySortBy || (InquirySortBy = {}));
var InterpretationSortBy;
(function(InterpretationSortBy) {
    InterpretationSortBy[/** 오름차순으로 해석 승인일자 정렬 */ "ApprovedAtAsc"] = "ApprovedAtAsc";
    InterpretationSortBy[/** 내림차순으로 해석 승인일자 정렬 */ "ApprovedAtDesc"] = "ApprovedAtDesc";
    InterpretationSortBy[/** 오름차순으로 생성일자 정렬 */ "CreatedAtAsc"] = "CreatedAtAsc";
    InterpretationSortBy[/** 내림차순으로 생성일자 정렬 */ "CreatedAtDesc"] = "CreatedAtDesc";
    InterpretationSortBy[/** 오름차순으로 해석 종료일자 정렬 */ "FinishedAtAsc"] = "FinishedAtAsc";
    InterpretationSortBy[/** 내림차순으로 해석 종료일자 정렬 */ "FinishedAtDesc"] = "FinishedAtDesc";
    InterpretationSortBy[/** 오름차순으로 환자 ID 정렬 */ "PatientIdAsc"] = "PatientIdAsc";
    InterpretationSortBy[/** 내림차순으로 환자 ID 정렬 */ "PatientIdDesc"] = "PatientIdDesc";
    InterpretationSortBy[/** 오름차순으로 의료인 ID 정렬 */ "ProfessionalIdAsc"] = "ProfessionalIdAsc";
    InterpretationSortBy[/** 내림차순으로 의료인 ID 정렬 */ "ProfessionalIdDesc"] = "ProfessionalIdDesc";
    InterpretationSortBy[/** 오름차순으로 해석 승인거절일자 정렬 */ "RejectedAtAsc"] = "RejectedAtAsc";
    InterpretationSortBy[/** 내림차순으로 해석 승인거절일자 정렬 */ "RejectedAtDesc"] = "RejectedAtDesc";
    InterpretationSortBy[/** 오름차순으로 해석 시작일자 정렬 */ "StartedAtAsc"] = "StartedAtAsc";
    InterpretationSortBy[/** 내림차순으로 해석 시작일자 정렬 */ "StartedAtDesc"] = "StartedAtDesc";
})(InterpretationSortBy || (InterpretationSortBy = {}));
var InterpretationStatus;
(function(InterpretationStatus) {
    InterpretationStatus[/** 관리자로부터 해석이 승인됨 */ "Approved"] = "Approved";
    InterpretationStatus[/** 의료인이 해석을 마치고 관리자의 승인을 기다리는 중 */ "Finished"] = "Finished";
    InterpretationStatus[/** 의료인의 해석을 관리자가 거부함 */ "Rejected"] = "Rejected";
    InterpretationStatus[/** 의료인이 해석할 결과지를 선택하여 해석이 진행중 */ "Started"] = "Started";
})(InterpretationStatus || (InterpretationStatus = {}));
var NoticeSortBy;
(function(NoticeSortBy) {
    NoticeSortBy[/** 오름차순으로 생성일자 정렬 */ "CreatedAtAsc"] = "CreatedAtAsc";
    NoticeSortBy[/** 내림차순으로 생성일자 정렬 */ "CreatedAtDesc"] = "CreatedAtDesc";
})(NoticeSortBy || (NoticeSortBy = {}));
var NoticeType;
(function(NoticeType) {
    NoticeType[/** 이벤트 */ "Event"] = "Event";
    NoticeType[/** 뉴스 */ "News"] = "News";
    NoticeType[/** 공지사항 */ "Notice"] = "Notice";
})(NoticeType || (NoticeType = {}));
var RelationshipSortBy;
(function(RelationshipSortBy) {
    RelationshipSortBy[/** 오름차순으로 생성일자 정렬 */ "CreatedAtAsc"] = "CreatedAtAsc";
    RelationshipSortBy[/** 내림차순으로 생성일자 정렬 */ "CreatedAtDesc"] = "CreatedAtDesc";
    RelationshipSortBy[/** 오름차순으로 ID 정렬 */ "IdAsc"] = "IdAsc";
    RelationshipSortBy[/** 내림차순으로 ID 정렬 */ "IdDesc"] = "IdDesc";
    RelationshipSortBy[/** 오름차순으로 이름 정렬 */ "NameAsc"] = "NameAsc";
    RelationshipSortBy[/** 내림차순으로 이름 정렬 */ "NameDesc"] = "NameDesc";
})(RelationshipSortBy || (RelationshipSortBy = {}));
var UploadType;
(function(UploadType) {
    UploadType[/** 의료인 증명서 */ "Certificate"] = "Certificate";
    UploadType[/** 검사지 자료 */ "ExaminationResource"] = "ExaminationResource";
    UploadType[/** 회원용 1대1 문의 첨부자료 */ "InquiryByMember"] = "InquiryByMember";
    UploadType[/** 비회원용 1대1 문의 첨부자료 */ "InquiryByNonMember"] = "InquiryByNonMember";
    UploadType[/** 공지사항 */ "Notice"] = "Notice";
    UploadType[/** 프로필 이미지 */ "ProfileImage"] = "ProfileImage";
})(UploadType || (UploadType = {}));
var UserRole;
(function(UserRole) {
    UserRole[/** 관리자 */ "Admin"] = "Admin";
    UserRole[/** 환자 */ "Patient"] = "Patient";
    UserRole[/** 의료인 */ "Professional"] = "Professional";
})(UserRole || (UserRole = {}));
var UserSortBy;
(function(UserSortBy) {
    UserSortBy[/** 오름차순으로 생성일자 정렬 */ "CreatedAtAsc"] = "CreatedAtAsc";
    UserSortBy[/** 내림차순으로 생성일자 정렬 */ "CreatedAtDesc"] = "CreatedAtDesc";
    UserSortBy[/** 오름차순으로 이메일 정렬 */ "EmailAsc"] = "EmailAsc";
    UserSortBy[/** 내림차순으로 이메일 정렬 */ "EmailDesc"] = "EmailDesc";
    UserSortBy[/** 오름차순으로 group(분류) 정렬 */ "GroupAsc"] = "GroupAsc";
    UserSortBy[/** 내림차순으로 group(분류) 정렬 */ "GroupDesc"] = "GroupDesc";
    UserSortBy[/** 오름차순으로 해석 수 정렬 */ "InterpretationCountAsc"] = "InterpretationCountAsc";
    UserSortBy[/** 내림차순으로 해석 수 정렬 */ "InterpretationCountDesc"] = "InterpretationCountDesc";
    UserSortBy[/** 오름차순으로 해석 수 정렬 */ "InterpretationSevenDaysCountAsc"] = "InterpretationSevenDaysCountAsc";
    UserSortBy[/** 내림차순으로 해석 수 정렬 */ "InterpretationSevenDaysCountDesc"] = "InterpretationSevenDaysCountDesc";
    UserSortBy[/** 내림차순으로 마지막 해석일 정렬 */ "LastInterpretationAtAsc"] = "LastInterpretationAtAsc";
    UserSortBy[/** 내림차순으로 마지막 해석일 정렬 */ "LastInterpretationAtDesc"] = "LastInterpretationAtDesc";
    UserSortBy[/** 오름차순으로 마지막 로그인 정렬 */ "LastLoginAtAsc"] = "LastLoginAtAsc";
    UserSortBy[/** 내림차순으로 마지막 로그인 정렬 */ "LastLoginAtDesc"] = "LastLoginAtDesc";
    UserSortBy[/** 오름차순으로 Nickname 정렬 */ "NicknameAsc"] = "NicknameAsc";
    UserSortBy[/** 내림차순으로 Nickname 정렬 */ "NicknameDesc"] = "NicknameDesc";
    UserSortBy[/** 오름차순으로 Public ID 정렬 */ "PublicIdAsc"] = "PublicIdAsc";
    UserSortBy[/** 내림차순으로 Public ID 정렬 */ "PublicIdDesc"] = "PublicIdDesc";
    UserSortBy[/** 오름차순으로 환자와의 관계 정렬 */ "RelationshipAsc"] = "RelationshipAsc";
    UserSortBy[/** 내림차순으로 환자와의 관계 정렬 */ "RelationshipDesc"] = "RelationshipDesc";
    UserSortBy[/** 오름차순으로 신청일 정렬 */ "RequestedAtAsc"] = "RequestedAtAsc";
    UserSortBy[/** 내림차순으로 신청일 정렬 */ "RequestedAtDesc"] = "RequestedAtDesc";
    UserSortBy["SevenDaysCountAsc"] = "SevenDaysCountAsc";
    UserSortBy["SevenDaysCountDesc"] = "SevenDaysCountDesc";
    UserSortBy[/** 오름차순으로 상태 정렬 */ "StatusAsc"] = "StatusAsc";
    UserSortBy[/** 내림차순으로 상태 정렬 */ "StatusDesc"] = "StatusDesc";
    UserSortBy["TotalCountAsc"] = "TotalCountAsc";
    UserSortBy["TotalCountDesc"] = "TotalCountDesc";
    UserSortBy[/** 오름차순으로 총 정산 금액 정렬 */ "TotalEarningsAsc"] = "TotalEarningsAsc";
    UserSortBy[/** 내림차순으로 총 정산 금액 정렬 */ "TotalEarningsDesc"] = "TotalEarningsDesc";
})(UserSortBy || (UserSortBy = {}));
var BankAccountPartsFragmentDoc = {
    kind: "Document",
    definitions: [
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "BankAccountParts"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "BankAccount"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "accountHolder"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "accountNumber"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "bankId"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "bank"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "code"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "name"
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "createdAt"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "updatedAt"
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var DiseasePartsFragmentDoc = {
    kind: "Document",
    definitions: [
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "DiseaseParts"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "Disease"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "name"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "image"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "isMajor"
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var ExaminationToDiseasePartsFragmentDoc = {
    kind: "Document",
    definitions: [
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "ExaminationToDiseaseParts"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "ExaminationToDisease"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "examinationId"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "diseaseId"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "createdAt"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "updatedAt"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "disease"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "DiseaseParts"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(DiseasePartsFragmentDoc.definitions))
};
var MedicalImagingTypePartsFragmentDoc = {
    kind: "Document",
    definitions: [
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "MedicalImagingTypeParts"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "MedicalImagingType"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "name"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "image"
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var ExaminationToMedicalImagingTypePartsFragmentDoc = {
    kind: "Document",
    definitions: [
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "ExaminationToMedicalImagingTypeParts"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "ExaminationToMedicalImagingType"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "examinationId"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "medicalImagingTypeId"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "createdAt"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "updatedAt"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "medicalImagingType"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "MedicalImagingTypeParts"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(MedicalImagingTypePartsFragmentDoc.definitions))
};
var EarningPartsFragmentDoc = {
    kind: "Document",
    definitions: [
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "EarningParts"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "Earning"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "amounts"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "interpretationId"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "professionalId"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "createdAt"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "updatedAt"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "settlement"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "paidAt"
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "interpretation"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "status"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "contentLength"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "correctedContentLength"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "examination"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "id"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "publicId"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "status"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "title"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "createdAt"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "patient"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "id"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "publicId"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "nickname"
                                                            }
                                                        }, 
                                                    ]
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "examinationToFiles"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "id"
                                                            }
                                                        }, 
                                                    ]
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "examinationToDiseases"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "FragmentSpread",
                                                            name: {
                                                                kind: "Name",
                                                                value: "ExaminationToDiseaseParts"
                                                            }
                                                        }, 
                                                    ]
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "examinationToMedicalImagingTypes"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "FragmentSpread",
                                                            name: {
                                                                kind: "Name",
                                                                value: "ExaminationToMedicalImagingTypeParts"
                                                            }
                                                        }, 
                                                    ]
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "professional"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "user"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "id"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "email"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "nickname"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "publicId"
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(ExaminationToDiseasePartsFragmentDoc.definitions), (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(ExaminationToMedicalImagingTypePartsFragmentDoc.definitions))
};
var FilePartsFragmentDoc = {
    kind: "Document",
    definitions: [
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "FileParts"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "File"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "originName"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "key"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "size"
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var InterpretationPartsFragmentDoc = {
    kind: "Document",
    definitions: [
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "InterpretationParts"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "Interpretation"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "content"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "contentLength"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "correctedContent"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "correctedContentLength"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "status"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "startedAt"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "finishedAt"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "savedAt"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "approvedAt"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "professionalId"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "examinationId"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "createdAt"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "updatedAt"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "rejectedAt"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "inspection"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "note"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "accuracyScore"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "expressionScore"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "complianceScore"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "honestyScore"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "averageScore"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "createdAt"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "inspector"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "id"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "user"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "nickname"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "publicId"
                                                            }
                                                        }, 
                                                    ]
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "professional"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "user"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "id"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "nickname"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "email"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "publicId"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "profileImage"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "id"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "key"
                                                            }
                                                        }, 
                                                    ]
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "earning"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "amounts"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var ExaminationPartsFragmentDoc = {
    kind: "Document",
    definitions: [
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "ExaminationParts"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "Examination"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "publicId"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "createdAt"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "updatedAt"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "title"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "description"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "examinationDate"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "deletedAt"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "status"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "patientId"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "validatedAt"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "invalidatedAt"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "invalidationReason"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "hospitalId"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "hospital"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "name"
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "examinationToDiseases"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "ExaminationToDiseaseParts"
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "examinationToMedicalImagingTypes"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "ExaminationToMedicalImagingTypeParts"
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "examinationToFiles"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "file"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "FragmentSpread",
                                                name: {
                                                    kind: "Name",
                                                    value: "FileParts"
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "patient"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "publicId"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "nickname"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "profileImage"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "FragmentSpread",
                                                name: {
                                                    kind: "Name",
                                                    value: "FileParts"
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "interpretation"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "InterpretationParts"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(ExaminationToDiseasePartsFragmentDoc.definitions), (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(ExaminationToMedicalImagingTypePartsFragmentDoc.definitions), (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(FilePartsFragmentDoc.definitions), (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(InterpretationPartsFragmentDoc.definitions))
};
var ExaminationCountPartsFragmentDoc = {
    kind: "Document",
    definitions: [
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "ExaminationCountParts"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "ExaminationCounts"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "total"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "pending"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "waiting"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "interpreting"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "done"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "invalid"
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var FaqPartsFragmentDoc = {
    kind: "Document",
    definitions: [
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "FaqParts"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "Faq"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "title"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "description"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "categoryId"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "createdAt"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "updatedAt"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "category"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "name"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var InquiryPartsFragmentDoc = {
    kind: "Document",
    definitions: [
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "InquiryParts"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "Inquiry"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "isMember"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "email"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "question"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "title"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "answer"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "answeredAt"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "createdAt"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "updatedAt"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "questionerId"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "questioner"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "email"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "publicId"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "phoneNumber"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "name"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "role"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "nickname"
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "answererId"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "answerer"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "user"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "id"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "email"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "publicId"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "nickname"
                                                }
                                            }, 
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "createdAt"
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "inquiryToFiles"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "file"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "FragmentSpread",
                                                name: {
                                                    kind: "Name",
                                                    value: "FileParts"
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(FilePartsFragmentDoc.definitions))
};
var InspectionPartsFragmentDoc = {
    kind: "Document",
    definitions: [
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "InspectionParts"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "Inspection"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "inspectorId"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "interpretationId"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "note"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "createdAt"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "updatedAt"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "averageScore"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "accuracyScore"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "complianceScore"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "expressionScore"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "honestyScore"
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var NoticePartsFragmentDoc = {
    kind: "Document",
    definitions: [
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "NoticeParts"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "Notice"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "title"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "type"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "createdAt"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "updatedAt"
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var OffsetPageInfoPartsFragmentDoc = {
    kind: "Document",
    definitions: [
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "OffsetPageInfoParts"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "OffsetPageInfo"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "hasPreviousPage"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "hasNextPage"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "countCurrent"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "countTotal"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "countBefore"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "countNext"
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var CursorPageInfoPartsFragmentDoc = {
    kind: "Document",
    definitions: [
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "CursorPageInfoParts"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "CursorPageInfo"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "hasPreviousPage"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "hasNextPage"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "countCurrent"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "countTotal"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "countBefore"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "countNext"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "endCursor"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "startCursor"
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var ProfessionalEarningsPartsFragmentDoc = {
    kind: "Document",
    definitions: [
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "ProfessionalEarningsParts"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "Professional"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "group"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "name"
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "user"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "publicId"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "email"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "nickname"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "bankAccount"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "bank"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "id"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "name"
                                                            }
                                                        }, 
                                                    ]
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "accountNumber"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "accountHolder"
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "earnings"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "settlementId"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "amounts"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var RelationshipPartsFragmentDoc = {
    kind: "Document",
    definitions: [
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "RelationshipParts"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "Relationship"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "name"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "isMajor"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "createdAt"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "updatedAt"
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var SettlementPartsFragmentDoc = {
    kind: "Document",
    definitions: [
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "SettlementParts"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "Settlement"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "createdAt"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "startDate"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "endDate"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "totalCount"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "totalAmount"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "paidAt"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "updatedAt"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "dueDate"
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var SettlementWithEarningsPartsFragmentDoc = {
    kind: "Document",
    definitions: [
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "SettlementWithEarningsParts"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "Settlement"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "createdAt"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "startDate"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "endDate"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "totalCount"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "totalAmount"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "paidAt"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "updatedAt"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "dueDate"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "numberOfTimes"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "earnings"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "amounts"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var UserSettingPartsFragmentDoc = {
    kind: "Document",
    definitions: [
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "UserSettingParts"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "UserSetting"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "serviceSmsNotification"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "serviceEmailNotification"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "promotionSmsNotification"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "userId"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "promotionEmailNotification"
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var UserToDiseasePartsFragmentDoc = {
    kind: "Document",
    definitions: [
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "UserToDiseaseParts"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "UserToDisease"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "userId"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "diseaseId"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "createdAt"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "updatedAt"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "disease"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "DiseaseParts"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(DiseasePartsFragmentDoc.definitions))
};
var UserPartsFragmentDoc = {
    kind: "Document",
    definitions: [
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "UserParts"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "User"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "publicId"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "role"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "email"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "name"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "nickname"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "phoneNumber"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "profileImage"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "key"
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "professionalId"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "createdAt"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "updatedAt"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "lastLoginAt"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "blockedAt"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "deletedAt"
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var PatientUserPartsFragmentDoc = {
    kind: "Document",
    definitions: [
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "PatientUserParts"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "User"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "FragmentSpread",
                        name: {
                            kind: "Name",
                            value: "UserParts"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "userToDiseases"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "disease"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "id"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "name"
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "relationship"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "name"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(UserPartsFragmentDoc.definitions))
};
var CertificatePartsFragmentDoc = {
    kind: "Document",
    definitions: [
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "CertificateParts"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "Certificate"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "status"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "createdAt"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "updatedAt"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "validatedAt"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "rejectionReason"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "validator"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "user"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "id"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "nickname"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "email"
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "certificateToFiles"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "file"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "id"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "key"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "originName"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "size"
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var ProfessionalPartsFragmentDoc = {
    kind: "Document",
    definitions: [
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "ProfessionalParts"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "Professional"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "userId"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "createdAt"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "updatedAt"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "totalInterpretationCount"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "sevenDaysInterpretationCount"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "totalEarnings"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "spec"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "doctorMajor"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "doctorPosition"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "doctorType"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "nurseType"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "otherJob"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "studentGrade"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "yearsOfService"
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "latestInterpretation"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "createdAt"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "startedAt"
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "certificate"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "CertificateParts"
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "school"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "name"
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "hospital"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "name"
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "group"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "name"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(CertificatePartsFragmentDoc.definitions))
};
var ProfessionalUserPartsFragmentDoc = {
    kind: "Document",
    definitions: [
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "ProfessionalUserParts"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "User"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "FragmentSpread",
                        name: {
                            kind: "Name",
                            value: "UserParts"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "professional"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "ProfessionalParts"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(UserPartsFragmentDoc.definitions), (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(ProfessionalPartsFragmentDoc.definitions))
};
var AdminPartsFragmentDoc = {
    kind: "Document",
    definitions: [
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "AdminParts"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "Administrator"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "role"
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var AdministratorUserPartsFragmentDoc = {
    kind: "Document",
    definitions: [
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "AdministratorUserParts"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "User"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "FragmentSpread",
                        name: {
                            kind: "Name",
                            value: "UserParts"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "administrator"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "AdminParts"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(UserPartsFragmentDoc.definitions), (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(AdminPartsFragmentDoc.definitions))
};
var CreateAdministratorDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: {
                kind: "Name",
                value: "CreateAdministrator"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "input"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "CreateAdministratorInput"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "createAdministrator"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "input"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "input"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "UserParts"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "administrator"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "FragmentSpread",
                                                name: {
                                                    kind: "Name",
                                                    value: "AdminParts"
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(UserPartsFragmentDoc.definitions), (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(AdminPartsFragmentDoc.definitions))
};
var SetAdministratorDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: {
                kind: "Name",
                value: "SetAdministrator"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "input"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "SetAdministratorInput"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "setAdministrator"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "input"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "input"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "UserParts"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "administrator"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "FragmentSpread",
                                                name: {
                                                    kind: "Name",
                                                    value: "AdminParts"
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(UserPartsFragmentDoc.definitions), (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(AdminPartsFragmentDoc.definitions))
};
var UpdateAdministratorRoleDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: {
                kind: "Name",
                value: "UpdateAdministratorRole"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "input"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "UpdateAdministratorRoleInput"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "updateAdministratorRole"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "input"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "input"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "AdminParts"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(AdminPartsFragmentDoc.definitions))
};
var LoginDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: {
                kind: "Name",
                value: "Login"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "input"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "LoginInput"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "login"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "input"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "input"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "accessToken"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var LogoutDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: {
                kind: "Name",
                value: "Logout"
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "logout"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "ok"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var GetBankAccountByUserIdDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "GetBankAccountByUserId"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "userId"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "String"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        alias: {
                            kind: "Name",
                            value: "bankAccount"
                        },
                        name: {
                            kind: "Name",
                            value: "getBankAccountByUserId"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "userId"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "userId"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "BankAccountParts"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(BankAccountPartsFragmentDoc.definitions))
};
var CreateBankAccountDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: {
                kind: "Name",
                value: "CreateBankAccount"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "input"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "CreateBankAccountInput"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "createBankAccount"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "input"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "input"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "BankAccountParts"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(BankAccountPartsFragmentDoc.definitions))
};
var UpdateBankAccountDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: {
                kind: "Name",
                value: "UpdateBankAccount"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "input"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "UpdateBankAccountInput"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "updateBankAccount"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "input"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "input"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "BankAccountParts"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(BankAccountPartsFragmentDoc.definitions))
};
var RemoveBankAccountDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: {
                kind: "Name",
                value: "RemoveBankAccount"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "removeBankAccountId"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "String"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "removeBankAccount"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "id"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "removeBankAccountId"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "ok"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var UpsertBankAccountDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: {
                kind: "Name",
                value: "UpsertBankAccount"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "input"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "CreateBankAccountInput"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "upsertBankAccount"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "input"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "input"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "BankAccountParts"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(BankAccountPartsFragmentDoc.definitions))
};
var GetAllBanksDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "GetAllBanks"
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        alias: {
                            kind: "Name",
                            value: "banks"
                        },
                        name: {
                            kind: "Name",
                            value: "getAllBanks"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "code"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "name"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var ApproveCertificateDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: {
                kind: "Name",
                value: "ApproveCertificate"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "input"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "ApproveCertificateInput"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "approveCertificate"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "input"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "input"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "status"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "validatorId"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "validatedAt"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "validator"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "id"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "user"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "id"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "email"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "nickname"
                                                            }
                                                        }, 
                                                    ]
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var RejectCertificateDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: {
                kind: "Name",
                value: "RejectCertificate"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "input"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "RejectCertificateInput"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "rejectCertificate"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "input"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "input"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "status"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var ResetCertificateDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: {
                kind: "Name",
                value: "ResetCertificate"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "input"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "ResetCertificateInput"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "resetCertificate"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "input"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "input"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "status"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var GetCertificateByProfessionalIdDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "GetCertificateByProfessionalId"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "professionalId"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "String"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "getCertificateByProfessionalId"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "professionalId"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "professionalId"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "createdAt"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "status"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var GetAllDiseasesDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "GetAllDiseases"
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        alias: {
                            kind: "Name",
                            value: "allDiseases"
                        },
                        name: {
                            kind: "Name",
                            value: "getAllDiseases"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "DiseaseParts"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(DiseasePartsFragmentDoc.definitions))
};
var GetDiseasesByOffsetDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "GetDiseasesByOffset"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "limit"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "Int"
                            }
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "filter"
                        }
                    },
                    type: {
                        kind: "NamedType",
                        name: {
                            kind: "Name",
                            value: "DiseaseFilter"
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "offset"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "Int"
                            }
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "sortBy"
                        }
                    },
                    type: {
                        kind: "NamedType",
                        name: {
                            kind: "Name",
                            value: "DiseaseSortBy"
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        alias: {
                            kind: "Name",
                            value: "diseases"
                        },
                        name: {
                            kind: "Name",
                            value: "getDiseasesByOffset"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "limit"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "limit"
                                    }
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "filter"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "filter"
                                    }
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "offset"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "offset"
                                    }
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "sortBy"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "sortBy"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "pageInfo"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "FragmentSpread",
                                                name: {
                                                    kind: "Name",
                                                    value: "OffsetPageInfoParts"
                                                }
                                            }, 
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "edges"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "node"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "FragmentSpread",
                                                            name: {
                                                                kind: "Name",
                                                                value: "DiseaseParts"
                                                            }
                                                        }, 
                                                    ]
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(OffsetPageInfoPartsFragmentDoc.definitions), (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(DiseasePartsFragmentDoc.definitions))
};
var GetEarningssByCursorDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "GetEarningssByCursor"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "first"
                        }
                    },
                    type: {
                        kind: "NamedType",
                        name: {
                            kind: "Name",
                            value: "Int"
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "last"
                        }
                    },
                    type: {
                        kind: "NamedType",
                        name: {
                            kind: "Name",
                            value: "Int"
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "before"
                        }
                    },
                    type: {
                        kind: "NamedType",
                        name: {
                            kind: "Name",
                            value: "String"
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "after"
                        }
                    },
                    type: {
                        kind: "NamedType",
                        name: {
                            kind: "Name",
                            value: "String"
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "filter"
                        }
                    },
                    type: {
                        kind: "NamedType",
                        name: {
                            kind: "Name",
                            value: "EarningFilter"
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "getEarningsByCursor"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "first"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "first"
                                    }
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "before"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "before"
                                    }
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "last"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "last"
                                    }
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "after"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "after"
                                    }
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "filter"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "filter"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "pageInfo"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "FragmentSpread",
                                                name: {
                                                    kind: "Name",
                                                    value: "CursorPageInfoParts"
                                                }
                                            }, 
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "edges"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "cursor"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "node"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "FragmentSpread",
                                                            name: {
                                                                kind: "Name",
                                                                value: "EarningParts"
                                                            }
                                                        }, 
                                                    ]
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(CursorPageInfoPartsFragmentDoc.definitions), (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(EarningPartsFragmentDoc.definitions))
};
var GetEarningTotalAmountsByCursorDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "GetEarningTotalAmountsByCursor"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "first"
                        }
                    },
                    type: {
                        kind: "NamedType",
                        name: {
                            kind: "Name",
                            value: "Int"
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "after"
                        }
                    },
                    type: {
                        kind: "NamedType",
                        name: {
                            kind: "Name",
                            value: "String"
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "last"
                        }
                    },
                    type: {
                        kind: "NamedType",
                        name: {
                            kind: "Name",
                            value: "Int"
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "before"
                        }
                    },
                    type: {
                        kind: "NamedType",
                        name: {
                            kind: "Name",
                            value: "String"
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "filter"
                        }
                    },
                    type: {
                        kind: "NamedType",
                        name: {
                            kind: "Name",
                            value: "EarningFilter"
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "sortKey"
                        }
                    },
                    type: {
                        kind: "NamedType",
                        name: {
                            kind: "Name",
                            value: "EarningSortKey"
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "getEarningTotalAmountsByCursor"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "first"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "first"
                                    }
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "after"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "after"
                                    }
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "last"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "last"
                                    }
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "before"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "before"
                                    }
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "filter"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "filter"
                                    }
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "sortKey"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "sortKey"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "pageInfo"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "FragmentSpread",
                                                name: {
                                                    kind: "Name",
                                                    value: "CursorPageInfoParts"
                                                }
                                            }, 
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "edges"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "cursor"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "node"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "totalCount"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "totalAmount"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "settlementId"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "paidAt"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "startDate"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "endDate"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "dueDate"
                                                            }
                                                        }, 
                                                    ]
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(CursorPageInfoPartsFragmentDoc.definitions))
};
var GetEarningTotalAmountDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "GetEarningTotalAmount"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "filter"
                        }
                    },
                    type: {
                        kind: "NamedType",
                        name: {
                            kind: "Name",
                            value: "EarningFilter"
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "getEarningTotalAmount"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "filter"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "filter"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "totalAmount"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var GetEarningsStatisticsDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "GetEarningsStatistics"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "professionalId"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "String"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "getEarningsStatistics"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "professionalId"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "professionalId"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "totalCount"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "paidAmount"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "unpaidAmount"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "nextSettlementDate"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "unpaidCount"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "weekCount"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "monthCount"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "settlementCount"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var GetEarningsStatisticsForAdminDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "GetEarningsStatisticsForAdmin"
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "getEarningsStatisticsForAdmin"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "nextSettlementDate"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "paidAmount"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "unpaidAmount"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var GetEarningsByOffsetDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "GetEarningsByOffset"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "limit"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "Int"
                            }
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "filter"
                        }
                    },
                    type: {
                        kind: "NamedType",
                        name: {
                            kind: "Name",
                            value: "EarningFilter"
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "offset"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "Int"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        alias: {
                            kind: "Name",
                            value: "earnings"
                        },
                        name: {
                            kind: "Name",
                            value: "getEarningsByOffset"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "limit"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "limit"
                                    }
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "filter"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "filter"
                                    }
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "offset"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "offset"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "pageInfo"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "FragmentSpread",
                                                name: {
                                                    kind: "Name",
                                                    value: "OffsetPageInfoParts"
                                                }
                                            }, 
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "edges"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "node"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "FragmentSpread",
                                                            name: {
                                                                kind: "Name",
                                                                value: "EarningParts"
                                                            }
                                                        }, 
                                                    ]
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(OffsetPageInfoPartsFragmentDoc.definitions), (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(EarningPartsFragmentDoc.definitions))
};
var CreateExaminationDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: {
                kind: "Name",
                value: "CreateExamination"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "input"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "CreateExaminationInput"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "createExamination"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "input"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "input"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "ExaminationParts"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(ExaminationPartsFragmentDoc.definitions))
};
var UpdateExaminationDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: {
                kind: "Name",
                value: "UpdateExamination"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "input"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "UpdateExaminationInput"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "updateExamination"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "input"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "input"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "ExaminationParts"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(ExaminationPartsFragmentDoc.definitions))
};
var DeleteExaminationDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: {
                kind: "Name",
                value: "DeleteExamination"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "input"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "DeleteExaminationInput"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "deleteExamination"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "input"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "input"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "ok"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var GetExaminationsByOffsetDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "GetExaminationsByOffset"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "limit"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "Int"
                            }
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "offset"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "Int"
                            }
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "filter"
                        }
                    },
                    type: {
                        kind: "NamedType",
                        name: {
                            kind: "Name",
                            value: "ExaminationFilter"
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "sortBy"
                        }
                    },
                    type: {
                        kind: "NamedType",
                        name: {
                            kind: "Name",
                            value: "ExaminationSortBy"
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        alias: {
                            kind: "Name",
                            value: "examinations"
                        },
                        name: {
                            kind: "Name",
                            value: "getExaminationsByOffset"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "limit"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "limit"
                                    }
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "offset"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "offset"
                                    }
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "filter"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "filter"
                                    }
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "sortBy"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "sortBy"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "edges"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "node"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "FragmentSpread",
                                                            name: {
                                                                kind: "Name",
                                                                value: "ExaminationParts"
                                                            }
                                                        }, 
                                                    ]
                                                }
                                            }, 
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "pageInfo"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "FragmentSpread",
                                                name: {
                                                    kind: "Name",
                                                    value: "OffsetPageInfoParts"
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(ExaminationPartsFragmentDoc.definitions), (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(OffsetPageInfoPartsFragmentDoc.definitions))
};
var GetExaminationsInProgressByOffsetDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "GetExaminationsInProgressByOffset"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "limit"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "Int"
                            }
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "offset"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "Int"
                            }
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "filter"
                        }
                    },
                    type: {
                        kind: "NamedType",
                        name: {
                            kind: "Name",
                            value: "ExaminationFilter"
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "sortBy"
                        }
                    },
                    type: {
                        kind: "NamedType",
                        name: {
                            kind: "Name",
                            value: "ExaminationSortBy"
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        alias: {
                            kind: "Name",
                            value: "examinations"
                        },
                        name: {
                            kind: "Name",
                            value: "getExaminationsInProgressByOffset"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "limit"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "limit"
                                    }
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "offset"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "offset"
                                    }
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "filter"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "filter"
                                    }
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "sortBy"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "sortBy"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "edges"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "node"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "FragmentSpread",
                                                            name: {
                                                                kind: "Name",
                                                                value: "ExaminationParts"
                                                            }
                                                        }, 
                                                    ]
                                                }
                                            }, 
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "pageInfo"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "FragmentSpread",
                                                name: {
                                                    kind: "Name",
                                                    value: "OffsetPageInfoParts"
                                                }
                                            }, 
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "counts"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "waiting"
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(ExaminationPartsFragmentDoc.definitions), (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(OffsetPageInfoPartsFragmentDoc.definitions))
};
var GetExaminationDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "GetExamination"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "String"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        alias: {
                            kind: "Name",
                            value: "examination"
                        },
                        name: {
                            kind: "Name",
                            value: "getExamination"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "id"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "ExaminationParts"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(ExaminationPartsFragmentDoc.definitions))
};
var GetExaminationOptionsDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "GetExaminationOptions"
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        alias: {
                            kind: "Name",
                            value: "allDiseases"
                        },
                        name: {
                            kind: "Name",
                            value: "getAllDiseases"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "name"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "image"
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        alias: {
                            kind: "Name",
                            value: "allMedicalImagingTypes"
                        },
                        name: {
                            kind: "Name",
                            value: "getAllMedicalImagingTypes"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "name"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "image"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var ValidateExaminationDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: {
                kind: "Name",
                value: "ValidateExamination"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "String"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "validateExamination"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "id"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "status"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "validatedAt"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "invalidatedAt"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "invalidationReason"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "updatedAt"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var InvalidateExaminationDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: {
                kind: "Name",
                value: "InvalidateExamination"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "input"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "InvalidateExaminationInput"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "invalidateExamination"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "input"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "input"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "status"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "validatedAt"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "invalidatedAt"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "invalidationReason"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "updatedAt"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var GetExaminationCountsByUserIdDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "GetExaminationCountsByUserId"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "userId"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "String"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        alias: {
                            kind: "Name",
                            value: "examinationCounts"
                        },
                        name: {
                            kind: "Name",
                            value: "getExaminationCountsByUserId"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "userId"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "userId"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "total"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "pending"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "waiting"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "interpreting"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "done"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "invalid"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var GetAllFaqCategoriesDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "GetAllFaqCategories"
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        alias: {
                            kind: "Name",
                            value: "allFaqs"
                        },
                        name: {
                            kind: "Name",
                            value: "getAllFaqCategories"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "name"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "faqs"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "FragmentSpread",
                                                name: {
                                                    kind: "Name",
                                                    value: "FaqParts"
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(FaqPartsFragmentDoc.definitions))
};
var GetFaqsByOffsetDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "GetFaqsByOffset"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "limit"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "Int"
                            }
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "offset"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "Int"
                            }
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "sortBy"
                        }
                    },
                    type: {
                        kind: "NamedType",
                        name: {
                            kind: "Name",
                            value: "FaqSortBy"
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        alias: {
                            kind: "Name",
                            value: "faqs"
                        },
                        name: {
                            kind: "Name",
                            value: "getFaqsByOffset"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "limit"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "limit"
                                    }
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "offset"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "offset"
                                    }
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "sortBy"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "sortBy"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "edges"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "node"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "FragmentSpread",
                                                            name: {
                                                                kind: "Name",
                                                                value: "FaqParts"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "category"
                                                            },
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "id"
                                                                        }
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "name"
                                                                        }
                                                                    }, 
                                                                ]
                                                            }
                                                        }, 
                                                    ]
                                                }
                                            }, 
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "pageInfo"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "FragmentSpread",
                                                name: {
                                                    kind: "Name",
                                                    value: "OffsetPageInfoParts"
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(FaqPartsFragmentDoc.definitions), (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(OffsetPageInfoPartsFragmentDoc.definitions))
};
var GetFaqDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "GetFaq"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "String"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        alias: {
                            kind: "Name",
                            value: "faq"
                        },
                        name: {
                            kind: "Name",
                            value: "getFaq"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "id"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "FaqParts"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "category"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "id"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "name"
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(FaqPartsFragmentDoc.definitions))
};
var CreateFaqDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: {
                kind: "Name",
                value: "CreateFaq"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "input"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "CreateFaqInput"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "createFaq"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "input"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "input"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "FaqParts"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(FaqPartsFragmentDoc.definitions))
};
var UpdateFaqDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: {
                kind: "Name",
                value: "UpdateFaq"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "input"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "UpdateFaqInput"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "updateFaq"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "input"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "input"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "title"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "description"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "categoryId"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var DeleteFaqDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: {
                kind: "Name",
                value: "DeleteFaq"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "String"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "deleteFaq"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "id"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "ok"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "error"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var GenerateUploadPathDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: {
                kind: "Name",
                value: "GenerateUploadPath"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "input"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "GenerateUploadPathInput"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "generateUploadPath"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "input"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "input"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "signedUrl"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "key"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var CreateFileDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: {
                kind: "Name",
                value: "CreateFile"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "input"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "CreateFileInput"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        alias: {
                            kind: "Name",
                            value: "file"
                        },
                        name: {
                            kind: "Name",
                            value: "createFile"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "input"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "input"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "FileParts"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(FilePartsFragmentDoc.definitions))
};
var GenerateDownloadPathDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: {
                kind: "Name",
                value: "GenerateDownloadPath"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "key"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "String"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "generateDownloadPath"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "key"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "key"
                                    }
                                }
                            }, 
                        ]
                    }, 
                ]
            }
        }, 
    ]
};
var CreateFileByNonMemberDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: {
                kind: "Name",
                value: "CreateFileByNonMember"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "input"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "CreateFileInput"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        alias: {
                            kind: "Name",
                            value: "file"
                        },
                        name: {
                            kind: "Name",
                            value: "createFileByNonMember"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "input"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "input"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "FileParts"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(FilePartsFragmentDoc.definitions))
};
var GenerateUploadPathByNonMemberDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: {
                kind: "Name",
                value: "GenerateUploadPathByNonMember"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "input"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "GenerateUploadPathInput"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        alias: {
                            kind: "Name",
                            value: "generateUploadPath"
                        },
                        name: {
                            kind: "Name",
                            value: "generateUploadPathByNonMember"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "input"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "input"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "signedUrl"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "key"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var GetHospitalsByOffsetDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "GetHospitalsByOffset"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "limit"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "Int"
                            }
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "offset"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "Int"
                            }
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "filter"
                        }
                    },
                    type: {
                        kind: "NamedType",
                        name: {
                            kind: "Name",
                            value: "HospitalFilter"
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        alias: {
                            kind: "Name",
                            value: "hospitals"
                        },
                        name: {
                            kind: "Name",
                            value: "getHospitalsByOffset"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "limit"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "limit"
                                    }
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "offset"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "offset"
                                    }
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "filter"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "filter"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "pageInfo"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "FragmentSpread",
                                                name: {
                                                    kind: "Name",
                                                    value: "OffsetPageInfoParts"
                                                }
                                            }, 
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "edges"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "node"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "id"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "name"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "image"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "isMajor"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "createdAt"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "updatedAt"
                                                            }
                                                        }, 
                                                    ]
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(OffsetPageInfoPartsFragmentDoc.definitions))
};
var CreateIdentificationDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: {
                kind: "Name",
                value: "CreateIdentification"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "input"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "CreateIdentificationInput"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "createIdentification"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "input"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "input"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "userId"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var SaveIdentifiedUserDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: {
                kind: "Name",
                value: "SaveIdentifiedUser"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "input"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "SaveIdentifiedUserInput"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "saveIdentifiedUser"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "input"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "input"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "impUid"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "isIdentified"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "name"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "birthday"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "phoneNumber"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "identifiedAt"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "user"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "id"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "name"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "phoneNumber"
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var GetInquiriesByOffsetDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "GetInquiriesByOffset"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "limit"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "Int"
                            }
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "offset"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "Int"
                            }
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "filter"
                        }
                    },
                    type: {
                        kind: "NamedType",
                        name: {
                            kind: "Name",
                            value: "InquiryFilter"
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "sortBy"
                        }
                    },
                    type: {
                        kind: "NamedType",
                        name: {
                            kind: "Name",
                            value: "InquirySortBy"
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        alias: {
                            kind: "Name",
                            value: "inquiries"
                        },
                        name: {
                            kind: "Name",
                            value: "getInquiriesByOffset"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "limit"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "limit"
                                    }
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "offset"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "offset"
                                    }
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "filter"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "filter"
                                    }
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "sortBy"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "sortBy"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "edges"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "node"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "FragmentSpread",
                                                            name: {
                                                                kind: "Name",
                                                                value: "InquiryParts"
                                                            }
                                                        }, 
                                                    ]
                                                }
                                            }, 
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "pageInfo"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "FragmentSpread",
                                                name: {
                                                    kind: "Name",
                                                    value: "OffsetPageInfoParts"
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(InquiryPartsFragmentDoc.definitions), (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(OffsetPageInfoPartsFragmentDoc.definitions))
};
var GetInquiryDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "GetInquiry"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "String"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        alias: {
                            kind: "Name",
                            value: "inqiury"
                        },
                        name: {
                            kind: "Name",
                            value: "getInquiry"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "id"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "InquiryParts"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(InquiryPartsFragmentDoc.definitions))
};
var CreateAnswerDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: {
                kind: "Name",
                value: "CreateAnswer"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "input"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "CreateAnswerInput"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "createAnswer"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "input"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "input"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "email"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "answer"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "answeredAt"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "answererId"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "answerer"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "id"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "user"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "id"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "publicId"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "email"
                                                            }
                                                        }, 
                                                    ]
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var CreateInquiryByMemberDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: {
                kind: "Name",
                value: "CreateInquiryByMember"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "input"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "CreateInquiryInput"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "createInquiryByMember"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "input"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "input"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "InquiryParts"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(InquiryPartsFragmentDoc.definitions))
};
var CreateInquiryByNonMemberDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: {
                kind: "Name",
                value: "CreateInquiryByNonMember"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "input"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "CreateInquiryInput"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "createInquiryByNonMember"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "input"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "input"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "InquiryParts"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(InquiryPartsFragmentDoc.definitions))
};
var CreateInspectionDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: {
                kind: "Name",
                value: "CreateInspection"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "input"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "CreateInspectionInput"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "createInspection"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "input"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "input"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "InspectionParts"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(InspectionPartsFragmentDoc.definitions))
};
var UpdateInspectionScoreDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: {
                kind: "Name",
                value: "UpdateInspectionScore"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "input"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "UpdateInspectionScoreInput"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "updateInspectionScore"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "input"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "input"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "InspectionParts"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(InspectionPartsFragmentDoc.definitions))
};
var CreateInterpretationDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: {
                kind: "Name",
                value: "CreateInterpretation"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "input"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "CreateInterpretationInput"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "createInterpretation"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "input"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "input"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "InterpretationParts"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(InterpretationPartsFragmentDoc.definitions))
};
var GetInterpretationCountsDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "GetInterpretationCounts"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "professionalId"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "String"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "getInterpretationCounts"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "professionalId"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "professionalId"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "total"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "finished"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "inProgress"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "latestDate"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "averageRating"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var SubmitInterpretationDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: {
                kind: "Name",
                value: "SubmitInterpretation"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "input"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "SubmitInterpretationInput"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "submitInterpretation"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "input"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "input"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "content"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "status"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "finishedAt"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "savedAt"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "approvedAt"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "rejectedAt"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "rejectionReason"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "updatedAt"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "examinationId"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var SaveInterpretationDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: {
                kind: "Name",
                value: "SaveInterpretation"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "input"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "SaveInterpretationInput"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "saveInterpretation"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "input"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "input"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "content"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "savedAt"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var CancelInterpretationDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: {
                kind: "Name",
                value: "CancelInterpretation"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "String"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "cancelInterpretation"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "id"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "ok"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var GetSavedInterpretationsDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "GetSavedInterpretations"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "input"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "GetSavedInterpretationsInput"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        alias: {
                            kind: "Name",
                            value: "savedInterpretations"
                        },
                        name: {
                            kind: "Name",
                            value: "getSavedInterpretations"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "input"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "input"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "content"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "savedAt"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "examinationId"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var GetInterpretationsByOffsetDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "GetInterpretationsByOffset"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "limit"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "Int"
                            }
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "offset"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "Int"
                            }
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "filter"
                        }
                    },
                    type: {
                        kind: "NamedType",
                        name: {
                            kind: "Name",
                            value: "InterpretationFilter"
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "sortBy"
                        }
                    },
                    type: {
                        kind: "NamedType",
                        name: {
                            kind: "Name",
                            value: "InterpretationSortBy"
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        alias: {
                            kind: "Name",
                            value: "interpretations"
                        },
                        name: {
                            kind: "Name",
                            value: "getInterpretationsByOffset"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "limit"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "limit"
                                    }
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "offset"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "offset"
                                    }
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "filter"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "filter"
                                    }
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "sortBy"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "sortBy"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "pageInfo"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "FragmentSpread",
                                                name: {
                                                    kind: "Name",
                                                    value: "OffsetPageInfoParts"
                                                }
                                            }, 
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "edges"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "node"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "id"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "status"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "startedAt"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "deadline"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "finishedAt"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "savedAt"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "approvedAt"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "rejectedAt"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "rejectionReason"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "professionalId"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "examinationId"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "updatedAt"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "createdAt"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "examination"
                                                            },
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "FragmentSpread",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "ExaminationParts"
                                                                        }
                                                                    }, 
                                                                ]
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "professional"
                                                            },
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "id"
                                                                        }
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "user"
                                                                        },
                                                                        selectionSet: {
                                                                            kind: "SelectionSet",
                                                                            selections: [
                                                                                {
                                                                                    kind: "Field",
                                                                                    name: {
                                                                                        kind: "Name",
                                                                                        value: "publicId"
                                                                                    }
                                                                                }, 
                                                                            ]
                                                                        }
                                                                    }, 
                                                                ]
                                                            }
                                                        }, 
                                                    ]
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(OffsetPageInfoPartsFragmentDoc.definitions), (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(ExaminationPartsFragmentDoc.definitions))
};
var GetInterpretationDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "GetInterpretation"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "String"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        alias: {
                            kind: "Name",
                            value: "interpretation"
                        },
                        name: {
                            kind: "Name",
                            value: "getInterpretation"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "id"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "content"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "status"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "startedAt"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "finishedAt"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "savedAt"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "approvedAt"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "rejectedAt"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "rejectionReason"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "professionalId"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "createdAt"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "examinationId"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "updatedAt"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "professional"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "id"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "user"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "publicId"
                                                            }
                                                        }, 
                                                    ]
                                                }
                                            }, 
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "inspection"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "id"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "note"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "accuracyScore"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "expressionScore"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "complianceScore"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "honestyScore"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "averageScore"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "createdAt"
                                                }
                                            }, 
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "examination"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "id"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "description"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "status"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "examinationDate"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "patientId"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "createdAt"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "patient"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "email"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "name"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "phoneNumber"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "profileImage"
                                                            },
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "id"
                                                                        }
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "key"
                                                                        }
                                                                    }, 
                                                                ]
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "role"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "publicId"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "id"
                                                            }
                                                        }, 
                                                    ]
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "examinationToDiseases"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "id"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "disease"
                                                            },
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "id"
                                                                        }
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "name"
                                                                        }
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "image"
                                                                        }
                                                                    }, 
                                                                ]
                                                            }
                                                        }, 
                                                    ]
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "examinationToFiles"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "id"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "file"
                                                            },
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "id"
                                                                        }
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "key"
                                                                        }
                                                                    }, 
                                                                ]
                                                            }
                                                        }, 
                                                    ]
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "examinationToMedicalImagingTypes"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "id"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "medicalImagingType"
                                                            },
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "id"
                                                                        }
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "name"
                                                                        }
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "image"
                                                                        }
                                                                    }, 
                                                                ]
                                                            }
                                                        }, 
                                                    ]
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var ApproveInterpretationDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: {
                kind: "Name",
                value: "ApproveInterpretation"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "input"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "ApproveInterpretationInput"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "approveInterpretation"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "input"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "input"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "approvedAt"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "rejectedAt"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "status"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "rejectionReason"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "examination"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "id"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "status"
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var RejectInterpretationDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: {
                kind: "Name",
                value: "RejectInterpretation"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "input"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "RejectInterpretationInput"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "rejectInterpretation"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "input"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "input"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "rejectedAt"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "rejectionReason"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "approvedAt"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "status"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "examination"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "id"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "status"
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var UpdateInterpretationDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: {
                kind: "Name",
                value: "UpdateInterpretation"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "input"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "UpdateInterpretationInput"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "updateInterpretation"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "input"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "input"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "InterpretationParts"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(InterpretationPartsFragmentDoc.definitions))
};
var GetAllMedicalImagingTypesDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "GetAllMedicalImagingTypes"
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        alias: {
                            kind: "Name",
                            value: "allMedicalImagingTypes"
                        },
                        name: {
                            kind: "Name",
                            value: "getAllMedicalImagingTypes"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "MedicalImagingTypeParts"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(MedicalImagingTypePartsFragmentDoc.definitions))
};
var CreateNoticeDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: {
                kind: "Name",
                value: "CreateNotice"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "input"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "CreateNoticeInput"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "createNotice"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "input"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "input"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "title"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "content"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "type"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "authorId"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "createdAt"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "updatedAt"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var GetNoticesByOffsetDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "GetNoticesByOffset"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "limit"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "Int"
                            }
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "offset"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "Int"
                            }
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "sortBy"
                        }
                    },
                    type: {
                        kind: "NamedType",
                        name: {
                            kind: "Name",
                            value: "NoticeSortBy"
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        alias: {
                            kind: "Name",
                            value: "notices"
                        },
                        name: {
                            kind: "Name",
                            value: "getNoticesByOffset"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "limit"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "limit"
                                    }
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "offset"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "offset"
                                    }
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "sortBy"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "sortBy"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "edges"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "node"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "FragmentSpread",
                                                            name: {
                                                                kind: "Name",
                                                                value: "NoticeParts"
                                                            }
                                                        }, 
                                                    ]
                                                }
                                            }, 
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "pageInfo"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "FragmentSpread",
                                                name: {
                                                    kind: "Name",
                                                    value: "OffsetPageInfoParts"
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(NoticePartsFragmentDoc.definitions), (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(OffsetPageInfoPartsFragmentDoc.definitions))
};
var GetNoticeDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "GetNotice"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "String"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        alias: {
                            kind: "Name",
                            value: "notice"
                        },
                        name: {
                            kind: "Name",
                            value: "getNotice"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "id"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "title"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "content"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "type"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "authorId"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "createdAt"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "updatedAt"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "author"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "id"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "user"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "id"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "email"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "name"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "publicId"
                                                            }
                                                        }, 
                                                    ]
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var DeleteNoticeDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: {
                kind: "Name",
                value: "DeleteNotice"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "String"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "deleteNotice"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "id"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "ok"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "error"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var UpdateNoticeDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: {
                kind: "Name",
                value: "UpdateNotice"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "input"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "UpdateNoticeInput"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "updateNotice"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "input"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "input"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "title"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "content"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "type"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "authorId"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var CreateProfessionalDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: {
                kind: "Name",
                value: "CreateProfessional"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "input"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "CreateProfessionalInput"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "createProfessional"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "input"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "input"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "ProfessionalParts"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(ProfessionalPartsFragmentDoc.definitions))
};
var GetAllProfessionalGroupsDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "GetAllProfessionalGroups"
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        alias: {
                            kind: "Name",
                            value: "allGroups"
                        },
                        name: {
                            kind: "Name",
                            value: "getAllProfessionalGroups"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "name"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var GetProfessionalEarningsByOffsetDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "GetProfessionalEarningsByOffset"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "limit"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "Int"
                            }
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "offset"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "Int"
                            }
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "filter"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "ProfessionalEarningsFilter"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        alias: {
                            kind: "Name",
                            value: "professionals"
                        },
                        name: {
                            kind: "Name",
                            value: "getProfessionalEarningsByOffset"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "limit"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "limit"
                                    }
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "offset"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "offset"
                                    }
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "filter"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "filter"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "pageInfo"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "FragmentSpread",
                                                name: {
                                                    kind: "Name",
                                                    value: "OffsetPageInfoParts"
                                                }
                                            }, 
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "edges"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "node"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "FragmentSpread",
                                                            name: {
                                                                kind: "Name",
                                                                value: "ProfessionalEarningsParts"
                                                            }
                                                        }, 
                                                    ]
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(OffsetPageInfoPartsFragmentDoc.definitions), (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(ProfessionalEarningsPartsFragmentDoc.definitions))
};
var DownloadProfessionalEarningsExcelDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "DownloadProfessionalEarningsExcel"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "settlementId"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "String"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "downloadProfessionalEarningsExcel"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "settlementId"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "settlementId"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "downloadUrl"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var GetRelationshipsByOffsetDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "GetRelationshipsByOffset"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "limit"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "Int"
                            }
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "filter"
                        }
                    },
                    type: {
                        kind: "NamedType",
                        name: {
                            kind: "Name",
                            value: "RelationshipFilter"
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "offset"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "Int"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        alias: {
                            kind: "Name",
                            value: "relationships"
                        },
                        name: {
                            kind: "Name",
                            value: "getRelationshipsByOffset"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "limit"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "limit"
                                    }
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "filter"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "filter"
                                    }
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "offset"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "offset"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "edges"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "node"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "FragmentSpread",
                                                            name: {
                                                                kind: "Name",
                                                                value: "RelationshipParts"
                                                            }
                                                        }, 
                                                    ]
                                                }
                                            }, 
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "pageInfo"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "FragmentSpread",
                                                name: {
                                                    kind: "Name",
                                                    value: "OffsetPageInfoParts"
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(RelationshipPartsFragmentDoc.definitions), (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(OffsetPageInfoPartsFragmentDoc.definitions))
};
var GetSettlementDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "GetSettlement"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "filter"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "SettlementFilter"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "getSettlement"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "filter"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "filter"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "SettlementParts"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(SettlementPartsFragmentDoc.definitions))
};
var GetLatestSettlementDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "GetLatestSettlement"
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        alias: {
                            kind: "Name",
                            value: "settlement"
                        },
                        name: {
                            kind: "Name",
                            value: "getLatestSettlement"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "SettlementParts"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(SettlementPartsFragmentDoc.definitions))
};
var GetSettlementsByOffsetDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "GetSettlementsByOffset"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "limit"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "Int"
                            }
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "offset"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "Int"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        alias: {
                            kind: "Name",
                            value: "settlements"
                        },
                        name: {
                            kind: "Name",
                            value: "getSettlementsByOffset"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "limit"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "limit"
                                    }
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "offset"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "offset"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "pageInfo"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "FragmentSpread",
                                                name: {
                                                    kind: "Name",
                                                    value: "OffsetPageInfoParts"
                                                }
                                            }, 
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "edges"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "node"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "FragmentSpread",
                                                            name: {
                                                                kind: "Name",
                                                                value: "SettlementWithEarningsParts"
                                                            }
                                                        }, 
                                                    ]
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(OffsetPageInfoPartsFragmentDoc.definitions), (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(SettlementWithEarningsPartsFragmentDoc.definitions))
};
var CompleteSettlementDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: {
                kind: "Name",
                value: "CompleteSettlement"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "input"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "CompleteSettlementTransactionInput"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "completeSettlement"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "input"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "input"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "endDate"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "dueDate"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "numberOfTimes"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "paidAt"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "startDate"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var UpdateSettlementDueDateDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: {
                kind: "Name",
                value: "UpdateSettlementDueDate"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "input"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "UpdateSettlementDueDateInput"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "updateSettlementDueDate"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "input"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "input"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "endDate"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "dueDate"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "numberOfTimes"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "paidAt"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "startDate"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var GetAdminHomeStatisticsDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "GetAdminHomeStatistics"
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        alias: {
                            kind: "Name",
                            value: "diseases"
                        },
                        name: {
                            kind: "Name",
                            value: "getDiseaseStatistics"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "name"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "count"
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        alias: {
                            kind: "Name",
                            value: "medicalImagingTypes"
                        },
                        name: {
                            kind: "Name",
                            value: "getMedicalImagingTypeStatistics"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "name"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "count"
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        alias: {
                            kind: "Name",
                            value: "users"
                        },
                        name: {
                            kind: "Name",
                            value: "getUserStatistics"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "total"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "patientCount"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "professionalCount"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "todaysNewUsersCount"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "yesterdaysNewUsersCount"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "rateOfRise"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "newUsers"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "id"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "publicId"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "createdAt"
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        alias: {
                            kind: "Name",
                            value: "certificates"
                        },
                        name: {
                            kind: "Name",
                            value: "getCertificateStatistics"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "total"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "waiting"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "certified"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "rejected"
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        alias: {
                            kind: "Name",
                            value: "examinations"
                        },
                        name: {
                            kind: "Name",
                            value: "getExaminationStatistics"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "total"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "pending"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "invalid"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "waiting"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "interpretingStarted"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "interpretingFinished"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "done"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "exceeded"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "newExaminationsCount"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "rateOfRise"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "todaysNewExaminationsCount"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "yesterdaysNewExaminationsCount"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "newExaminations"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "id"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "publicId"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "createdAt"
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        alias: {
                            kind: "Name",
                            value: "inquiries"
                        },
                        name: {
                            kind: "Name",
                            value: "getInquiryStatistics"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "total"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "waiting"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var UpdateUserSettingsDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: {
                kind: "Name",
                value: "UpdateUserSettings"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "input"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "UpdateUserSettingsInput"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "updateUserSettings"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "input"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "input"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var GetUserSettingDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "GetUserSetting"
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        alias: {
                            kind: "Name",
                            value: "setting"
                        },
                        name: {
                            kind: "Name",
                            value: "getUserSetting"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "UserSettingParts"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(UserSettingPartsFragmentDoc.definitions))
};
var SetUserToDiseasesDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: {
                kind: "Name",
                value: "SetUserToDiseases"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "input"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "SetUserToDiseasesInput"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "setUserToDiseases"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "input"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "input"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "UserToDiseaseParts"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(UserToDiseasePartsFragmentDoc.definitions))
};
var MeDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "Me"
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "me"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "UserParts"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(UserPartsFragmentDoc.definitions))
};
var AdminMeDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "AdminMe"
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "me"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "UserParts"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "administrator"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "FragmentSpread",
                                                name: {
                                                    kind: "Name",
                                                    value: "AdminParts"
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(UserPartsFragmentDoc.definitions), (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(AdminPartsFragmentDoc.definitions))
};
var PatientMeDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "PatientMe"
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "me"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "UserParts"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "userToDiseases"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "FragmentSpread",
                                                name: {
                                                    kind: "Name",
                                                    value: "UserToDiseaseParts"
                                                }
                                            }, 
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "relationship"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "FragmentSpread",
                                                name: {
                                                    kind: "Name",
                                                    value: "RelationshipParts"
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(UserPartsFragmentDoc.definitions), (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(UserToDiseasePartsFragmentDoc.definitions), (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(RelationshipPartsFragmentDoc.definitions))
};
var ProfessionalMeDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "ProfessionalMe"
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "me"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "UserParts"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "professional"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "FragmentSpread",
                                                name: {
                                                    kind: "Name",
                                                    value: "ProfessionalParts"
                                                }
                                            }, 
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "bankAccount"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "FragmentSpread",
                                                name: {
                                                    kind: "Name",
                                                    value: "BankAccountParts"
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(UserPartsFragmentDoc.definitions), (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(ProfessionalPartsFragmentDoc.definitions), (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(BankAccountPartsFragmentDoc.definitions))
};
var GetUsersByOffsetDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "GetUsersByOffset"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "limit"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "Int"
                            }
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "filter"
                        }
                    },
                    type: {
                        kind: "NamedType",
                        name: {
                            kind: "Name",
                            value: "UserFilter"
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "offset"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "Int"
                            }
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "sortBy"
                        }
                    },
                    type: {
                        kind: "NamedType",
                        name: {
                            kind: "Name",
                            value: "UserSortBy"
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        alias: {
                            kind: "Name",
                            value: "users"
                        },
                        name: {
                            kind: "Name",
                            value: "getUsersByOffset"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "limit"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "limit"
                                    }
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "filter"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "filter"
                                    }
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "offset"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "offset"
                                    }
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "sortBy"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "sortBy"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "edges"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "node"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "FragmentSpread",
                                                            name: {
                                                                kind: "Name",
                                                                value: "PatientUserParts"
                                                            }
                                                        }, 
                                                    ]
                                                }
                                            }, 
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "pageInfo"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "FragmentSpread",
                                                name: {
                                                    kind: "Name",
                                                    value: "OffsetPageInfoParts"
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(PatientUserPartsFragmentDoc.definitions), (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(OffsetPageInfoPartsFragmentDoc.definitions))
};
var GetProfessionalUsersByOffsetDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "GetProfessionalUsersByOffset"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "limit"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "Int"
                            }
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "filter"
                        }
                    },
                    type: {
                        kind: "NamedType",
                        name: {
                            kind: "Name",
                            value: "UserFilter"
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "offset"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "Int"
                            }
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "sortBy"
                        }
                    },
                    type: {
                        kind: "NamedType",
                        name: {
                            kind: "Name",
                            value: "UserSortBy"
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        alias: {
                            kind: "Name",
                            value: "users"
                        },
                        name: {
                            kind: "Name",
                            value: "getUsersByOffset"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "limit"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "limit"
                                    }
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "filter"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "filter"
                                    }
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "offset"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "offset"
                                    }
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "sortBy"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "sortBy"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "edges"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "node"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "FragmentSpread",
                                                            name: {
                                                                kind: "Name",
                                                                value: "ProfessionalUserParts"
                                                            }
                                                        }, 
                                                    ]
                                                }
                                            }, 
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "pageInfo"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "FragmentSpread",
                                                name: {
                                                    kind: "Name",
                                                    value: "OffsetPageInfoParts"
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(ProfessionalUserPartsFragmentDoc.definitions), (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(OffsetPageInfoPartsFragmentDoc.definitions))
};
var GetAdministratorUsersByOffsetDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "GetAdministratorUsersByOffset"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "limit"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "Int"
                            }
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "filter"
                        }
                    },
                    type: {
                        kind: "NamedType",
                        name: {
                            kind: "Name",
                            value: "UserFilter"
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "offset"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "Int"
                            }
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "sortBy"
                        }
                    },
                    type: {
                        kind: "NamedType",
                        name: {
                            kind: "Name",
                            value: "UserSortBy"
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        alias: {
                            kind: "Name",
                            value: "users"
                        },
                        name: {
                            kind: "Name",
                            value: "getUsersByOffset"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "limit"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "limit"
                                    }
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "filter"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "filter"
                                    }
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "offset"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "offset"
                                    }
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "sortBy"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "sortBy"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "edges"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "node"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "FragmentSpread",
                                                            name: {
                                                                kind: "Name",
                                                                value: "AdministratorUserParts"
                                                            }
                                                        }, 
                                                    ]
                                                }
                                            }, 
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "pageInfo"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "FragmentSpread",
                                                name: {
                                                    kind: "Name",
                                                    value: "OffsetPageInfoParts"
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(AdministratorUserPartsFragmentDoc.definitions), (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(OffsetPageInfoPartsFragmentDoc.definitions))
};
var GetProfessionalRegistrationsByOffsetDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "GetProfessionalRegistrationsByOffset"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "limit"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "Int"
                            }
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "offset"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "Int"
                            }
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "sortBy"
                        }
                    },
                    type: {
                        kind: "NamedType",
                        name: {
                            kind: "Name",
                            value: "UserSortBy"
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "filter"
                        }
                    },
                    type: {
                        kind: "NamedType",
                        name: {
                            kind: "Name",
                            value: "ProfessionalRegistrationFilter"
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        alias: {
                            kind: "Name",
                            value: "registrations"
                        },
                        name: {
                            kind: "Name",
                            value: "getProfessionalRegistrationsByOffset"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "limit"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "limit"
                                    }
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "offset"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "offset"
                                    }
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "sortBy"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "sortBy"
                                    }
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "filter"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "filter"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "pageInfo"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "FragmentSpread",
                                                name: {
                                                    kind: "Name",
                                                    value: "OffsetPageInfoParts"
                                                }
                                            }, 
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "edges"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "node"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "FragmentSpread",
                                                            name: {
                                                                kind: "Name",
                                                                value: "ProfessionalUserParts"
                                                            }
                                                        }, 
                                                    ]
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(OffsetPageInfoPartsFragmentDoc.definitions), (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(ProfessionalUserPartsFragmentDoc.definitions))
};
var GetUserByAdminDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "GetUserByAdmin"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "String"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        alias: {
                            kind: "Name",
                            value: "user"
                        },
                        name: {
                            kind: "Name",
                            value: "getUser"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "id"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "PatientUserParts"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "latestExamination"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "id"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "examinationDate"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "createdAt"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "examinationToDiseases"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "id"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "disease"
                                                            },
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "id"
                                                                        }
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "name"
                                                                        }
                                                                    }, 
                                                                ]
                                                            }
                                                        }, 
                                                    ]
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        alias: {
                            kind: "Name",
                            value: "examinationCounts"
                        },
                        name: {
                            kind: "Name",
                            value: "getExaminationCountsByUserId"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "userId"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "total"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "pending"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "waiting"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "interpreting"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "done"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "invalid"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(PatientUserPartsFragmentDoc.definitions))
};
var GetProfessionalUserDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "GetProfessionalUser"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "String"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        alias: {
                            kind: "Name",
                            value: "professionalUser"
                        },
                        name: {
                            kind: "Name",
                            value: "getUser"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "id"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "ProfessionalUserParts"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(ProfessionalUserPartsFragmentDoc.definitions))
};
var GetAdministratorUserDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "GetAdministratorUser"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "String"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        alias: {
                            kind: "Name",
                            value: "administratorUser"
                        },
                        name: {
                            kind: "Name",
                            value: "getUser"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "id"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "AdministratorUserParts"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(AdministratorUserPartsFragmentDoc.definitions))
};
var GetTotalUserCountDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "GetTotalUserCount"
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "getTotalUserCount"
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var SetRelationshipWithUserDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: {
                kind: "Name",
                value: "SetRelationshipWithUser"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "input"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "SetRelationshipWithUserInput"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "setRelationshipWithUser"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "input"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "input"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "relationship"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "FragmentSpread",
                                                name: {
                                                    kind: "Name",
                                                    value: "RelationshipParts"
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(RelationshipPartsFragmentDoc.definitions))
};
var SetProfileImageDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: {
                kind: "Name",
                value: "SetProfileImage"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "input"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "SetProfileImageInput"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "setProfileImage"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "input"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "input"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "UserParts"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(UserPartsFragmentDoc.definitions))
};
var BlockUserDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: {
                kind: "Name",
                value: "BlockUser"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "userId"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "String"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "blockUser"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "userId"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "userId"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var CheckPasswordDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: {
                kind: "Name",
                value: "CheckPassword"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "password"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "String"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "checkPassword"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "password"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "password"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "ok"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "error"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var ChangePasswordDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: {
                kind: "Name",
                value: "ChangePassword"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "password"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "String"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "changePassword"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "password"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "password"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "error"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "ok"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var DeleteUserDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: {
                kind: "Name",
                value: "DeleteUser"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "String"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "deleteUser"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "id"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "ok"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var CreateUserDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: {
                kind: "Name",
                value: "CreateUser"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "input"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "CreateUserInput"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "createUser"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "input"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "input"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "email"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var ResetPasswordDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: {
                kind: "Name",
                value: "ResetPassword"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "input"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "ResetPasswordInput"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "resetPassword"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "input"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "input"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "ok"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var UpdateUserDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: {
                kind: "Name",
                value: "UpdateUser"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "input"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "UpdateUserInput"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "updateUser"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "input"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "input"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "UserParts"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(UserPartsFragmentDoc.definitions))
};
var RequestEmailVerificationCodeDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: {
                kind: "Name",
                value: "RequestEmailVerificationCode"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "input"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "RequestEmailVerificationCodeInput"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "requestEmailVerificationCode"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "input"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "input"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "ok"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var ConfirmEmailVerificationCodeDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: {
                kind: "Name",
                value: "ConfirmEmailVerificationCode"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "input"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "ConfirmEmailVerificationCodeInput"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "confirmEmailVerificationCode"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "input"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "input"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "ok"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var RequestPhoneVerificationCodeDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: {
                kind: "Name",
                value: "RequestPhoneVerificationCode"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "input"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "RequestPhoneVerificationCodeInput"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "requestPhoneVerificationCode"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "input"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "input"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "ok"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var ConfirmPhoneVerificationCodeDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: {
                kind: "Name",
                value: "ConfirmPhoneVerificationCode"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "input"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "ConfirmPhoneVerificationCodeInput"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "confirmPhoneVerificationCode"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "input"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "input"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "ok"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ]
};


/***/ }),

/***/ 78954:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Routes; },
/* harmony export */   "i": function() { return /* binding */ AdminRoutes; }
/* harmony export */ });
var Routes = {
    ROOT: "/",
    HOME: "/home",
    // 인증
    AUTH_LOGIN: "/auth/login",
    AUTH_SIGNUP: "/auth/signup",
    AUTH_PASSWORD_RESET: "/auth/password-reset",
    AUTH_FORBIDDEN: "/auth/forbidden",
    AUTH_BLOCKED: "/auth/blocked",
    // 검사지 업로드
    UPLOAD: "/upload",
    UPLOAD_DETAILS: "/upload/:examinationId",
    UPLOAD_COMPLETE: "/upload/complete",
    // 환자 관련 페이지
    PATIENT_HOME: "/patient/home",
    PATIENT_EXAMINATIONS: "/patient/examinations",
    PATIENT_EXAMINATIONS_DETAIL: "/patient/examinations/:id",
    PATIENT_EXAMINATIONS_EDIT: "/patient/examinations/:id/edit",
    PATIENT_MEDICAL_INFO: "/patient/medical-info",
    PATIENT_INFORMATION_SET_DISEASES: "/patient/information/set-diseases",
    PATIENT_INFORMATION_SET_RELATIONSHIP: "/patient/information/set-relationship",
    // 의료인 관련 페이지
    DOCTOR_HOME: "/doctor/home",
    DOCTOR_PROFILE: "/doctor/profile",
    DOCTOR_REGISTRATION: "/doctor/registration",
    DOCTOR_REGISTRATION_COMPLETE: "/doctor/registration/complete",
    DOCTOR_EXAMINATIONS: "/doctor/examinations",
    DOCTOR_INTERPRETATIONS: "/doctor/interpretations",
    DOCTOR_INTERPRETATIONS_DETAIL: "/doctor/interpretations/:examinationId",
    DOCTOR_INTERPRETATION_WRITE_COMPLETE: "/doctor/interpretations/complete",
    DOCTOR_EARNINGS: "/doctor/earnings",
    DOCTOR_EARNINGS_DETAIL: "/doctor/earnings/:settlementId",
    // 고객센터
    SUPPORT_NOTICE: "/support/notice",
    SUPPORT_NOTICE_DETAIL: "/support/notice/:id",
    SUPPORT_INQUIRY_WRITE: "/support/inquiry/write",
    SUPPORT_FAQ: "/support/faq",
    // 설정
    SETTINGS_ACCOUNT: "/settings/account",
    SETTINGS_ACCOUNT_WITHDRAWAL: "/settings/account/withdrawal",
    SETTINGS_NOTIFICATIONS: "/settings/notifications",
    SETTINGS_INQUIRIES: "/settings/inquiries",
    SETTINGS_INQUIRIES_DETAIL: "/settings/inquiries/:id",
    // 기타
    LEGAL_PRIVACY_POLICY: "/legal/privacy-policy",
    LEGAL_TERMS_OF_SERVICE: "/legal/terms-of-service",
    LEGAL_TERMS_OF_USE_FOR_PAID_SERVICES: "/legal/terms-of-use-for-paid-services",
    // 노션
    NOTION_EARNINGS_INSTRUCTION: "https://tesser.notion.site/a9d9af8c69e04bbaa72331e4e4eb6976",
    NOTION_INTERPRETATION_GUIDE: "https://tesser.notion.site/8c610d742ae24273b80d400d5cdf096c",
    // 앱스토어
    APP_STORE: "https://apps.apple.com/kr/app/%EB%8B%A5%ED%84%B0%EC%98%A8%ED%86%A8/id1610327897",
    PLAY_STORE: "https://play.google.com/store/apps/details?id=kr.co.tesser.ontol",
    TESSER: "https://tesser.co.kr",
    TESSER_CONTACT: "https://www.tesser.co.kr/contact",
    /** 이전 온톨 다운로드 버튼 링크 */ // APPSTORE_AUTO_REDIRECT: 'https://redirect.ontol.com/go_web.html',
    APPSTORE_DYNAMIC_LINK: "https://link.ontol.com/ontol_link"
};
var AdminRoutes = {
    ROOT: "/admin",
    HOME: "/admin/home",
    AUTH_LOGIN: "/admin/auth/login",
    USERS: "/admin/users",
    USERS_DETAIL: "/admin/users/:id",
    PATIENTS: "/admin/patients",
    PATIENTS_DETAIL: "/admin/patients/:userId",
    PATIENTS_EXAMINATIONS: "/admin/patients/examinations/:userId",
    PROFESSIONALS: "/admin/professionals",
    PROFESSIONALS_DETAIL: "/admin/professionals/:userId",
    PROFESSIONALS_INTERPRETATIONS: "/admin/professionals/interpretations/:id",
    // Administrators
    ADMINISTRATORS: "/admin/administrators",
    ADMINISTRATORS_DETAIL: "/admin/administrators/:userId",
    // EXAMINATIONS: '/admin/examinations',
    EXAMINATIONS_PENDING: "/admin/examinations/pending",
    EXAMINATIONS_PENDING_DETAIL: "/admin/examinations/pending/:examinationId",
    EXAMINATIONS_INTERPRETING: "/admin/examinations/interpreting",
    EXAMINATIONS_INTERPRETING_SCORE: "/admin/examinations/interpreting/score/:interpretationId",
    EXAMINATIONS_INTERPRETING_DETAIL: "/admin/examinations/interpreting/:examinationId",
    EXAMINATIONS_DONE: "/admin/examinations/done",
    EXAMINATIONS_DONE_DETAIL: "/admin/examinations/done/:examinationId",
    REGISTRATIONS: "/admin/registrations",
    REGISTRATIONS_DETAIL: "/admin/registrations/:userId",
    INQUIRIES: "/admin/inquiries",
    INQUIRIES_DETAIL: "/admin/inquiries/:id",
    NOTICES: "/admin/notices",
    NOTICES_WRITE: "/admin/notices/write",
    NOTICES_DETAIL: "/admin/notices/:id",
    NOTICES_EDIT: "/admin/notices/edit/:id",
    FAQ: "/admin/faq",
    FAQ_WRITE: "/admin/faq/write",
    FAQ_DETAIL: "/admin/faq/:id",
    FAQ_EDIT: "/admin/faq/edit/:id",
    SETTINGS: "/admin/settings",
    SETTINGS_NEW_ACCOUNT: "/admin/settings/new-account",
    EARNINGS: "/admin/earnings",
    EARNINGS_DETAIL: "/admin/earnings/detail",
    EARNINGS_SETTLEMENT_DETAIL: "/admin/earnings/:settlementId"
};


/***/ }),

/***/ 24035:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ boxShadow; }
/* harmony export */ });
var boxShadowStyles = {
    borderBottom: "inset 0px -1px 0px #EEEEEE",
    borderTop: "inset 0px 1px 0px #EEEEEE"
};
var boxShadow = function(type) {
    return {
        boxShadow: boxShadowStyles[type]
    };
};


/***/ }),

/***/ 45500:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cg": function() { return /* binding */ border; },
/* harmony export */   "E0": function() { return /* binding */ borderRadius; },
/* harmony export */   "_7": function() { return /* binding */ flexCenter; },
/* harmony export */   "eP": function() { return /* binding */ rounded; },
/* harmony export */   "eR": function() { return /* binding */ transition; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29815);
/* harmony import */ var polished__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43281);



var flexCenter = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
};
var borderRadius = function(size) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, (0,polished__WEBPACK_IMPORTED_MODULE_1__/* .borderRadius */ .E0)("top", size + "px"), (0,polished__WEBPACK_IMPORTED_MODULE_1__/* .borderRadius */ .E0)("bottom", size + "px"));
};
var rounded = function(size) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, (0,polished__WEBPACK_IMPORTED_MODULE_1__/* .borderRadius */ .E0)("top", size + "px"), (0,polished__WEBPACK_IMPORTED_MODULE_1__/* .borderRadius */ .E0)("bottom", size + "px"));
};
var border = function(color) {
    var width = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [
        "1px"
    ], style = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "solid";
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, polished__WEBPACK_IMPORTED_MODULE_1__/* .borderWidth.apply */ .J4.apply(void 0, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(width)), (0,polished__WEBPACK_IMPORTED_MODULE_1__/* .borderStyle */ .$u)(style), (0,polished__WEBPACK_IMPORTED_MODULE_1__/* .borderColor */ .tv)(color));
};
var transition = function() {
    var property = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "all", duration = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "0.3s", timingFunction = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "ease-out";
    return {
        transitionProperty: property,
        transitionDuration: duration,
        transitionTimingFunction: timingFunction
    };
};


/***/ })

}]);